import { ClientGeoInfoApi } from '@unionfab/ufc-shop-commons';
import { Button, Modal } from 'antd';
import React, { useEffect, useState } from 'react';

import styles from './index.module.less';

export const SENSITIVE_COUNTRY_CODES = [
  'IR',
  'RU',
  'BY',
  'KP',
  'SY',
  'CU',
  'UA',
];
export const EXPORT_CONTROL_BLOCK_ISO2 = [
  'IR',
  'RU',
  'BY',
  'KP',
  'SY',
  'CU',
  'UA',
];
export const triggerExportControlModal = () => {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event('UF_OPEN_EXPORT_CONTROL_MODAL'));
  }
};
export const shouldBlockForExportControl = () => {
  try {
    const raw =
      typeof window !== 'undefined'
        ? window.localStorage.getItem('client-geo-info') || ''
        : '';
    let geo: any = {};
    try {
      geo = JSON.parse(raw);
    } catch {
      geo = raw;
    }
    const code = (geo?.country_code || geo?.countryCode || '').toUpperCase();
    if (code && EXPORT_CONTROL_BLOCK_ISO2.includes(code)) {
      triggerExportControlModal();
      return true;
    }
  } catch (_) {}
  return false;
};
export const EXPORT_CONTROL_BLOCK_COUNTRIES = [
  'Iran',
  'Russia',
  'Belarus',
  'North Korea',
  'Syria',
  'Cuba',
  'Ukraine',
];
export const shouldBlockForExportControlByCountryNames = (
  countryNames: string[],
) => {
  try {
    const normalize = (s: string) => (s || '').toLowerCase().trim();
    const blocked = new Set(EXPORT_CONTROL_BLOCK_COUNTRIES.map(normalize));
    const hasBlocked = (countryNames || []).some(n =>
      blocked.has(normalize(n)),
    );
    if (hasBlocked) {
      triggerExportControlModal();
      return true;
    }
  } catch (_) {}
  return false;
};

export const ExportControlModal: React.FC = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const checkGeoInfo = async () => {
      try {
        const api = ClientGeoInfoApi.getIns();
        await api.queryGeoInfoByIpApi();

        const countryCode = api.geoInfo?.country_code;

        if (
          countryCode &&
          SENSITIVE_COUNTRY_CODES.includes(countryCode.toUpperCase())
        ) {
          setVisible(true);
        }
      } catch (_) {}
    };

    checkGeoInfo();
  }, []);

  useEffect(() => {
    const open = () => setVisible(true);
    const close = () => setVisible(false);
    window.addEventListener('UF_OPEN_EXPORT_CONTROL_MODAL', open);
    window.addEventListener('UF_CLOSE_EXPORT_CONTROL_MODAL', close);
    return () => {
      window.removeEventListener('UF_OPEN_EXPORT_CONTROL_MODAL', open);
      window.removeEventListener('UF_CLOSE_EXPORT_CONTROL_MODAL', close);
    };
  }, []);

  const handleOk = () => {
    setVisible(false);
  };

  return (
    <Modal
      title="Notice"
      visible={visible}
      onCancel={handleOk}
      style={{ top: 180 }}
      footer={[
        <Button key="ok" type="primary" onClick={handleOk}>
          OK
        </Button>,
      ]}
      closable
      width={600}
      className={styles.exportControlModal}
    >
      <div className={styles.content}>
        <p className={styles.warningText}>
          Are any parts in this quote subject to export control regulations?
        </p>
        <p>
          The platform prohibits the export of components to highly sensitive
          regions such as Iran, Russia, Belarus, North Korea, Syria, Cuba, and
          Ukraine.
        </p>
      </div>
    </Modal>
  );
};
